<template>
  <gh-table-page v-model="selecteds" ref="table" :show-tabs="true" :args-query="argsQuery"
    module="mes.business.sys.file.service" cls="FileService">
    <template #area_query>
      <v-layout row align-center>
        <v-flex>
          <v-text-field v-model="argsQuery.keyword" counter :autofocus="true" clearable label="关键字"
            append-icon="mdi-circle-edit-outline" @change="$refs.table.query(argsQuery)">
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>
    <template #area_operation_before>
      <div style="margin: 0;padding: 0" v-if="selecteds.length === 1">
        <gh-upload :id="selecteds[0].Id"></gh-upload>
      </div>

    </template>
    <template #model-prop-Value="{prop,model}">
      <gh-upload v-if="!model.Id"></gh-upload>
    </template>
    <template #area_detail="{current}">
      <div v-if="current">
        <gh-pdf :id="current.Id" v-if="current.Type==='application/pdf'"></gh-pdf>
        <gh-video v-else-if="current.Type.indexOf('video') >- 1 " :source="current.Id"></gh-video>
        <gh-img v-else :id="current.Id"></gh-img>
      </div>
    </template>


  </gh-table-page>
</template>

<style scoped>

</style>

<script>
  import File from "./file.ts";
  export default File;
</script>